module.exports = __webpack_public_path__ + "img/famous-2.5ca60972.png";